import React from "react";
import isEqual from "lodash.isequal";
import PopupChecklist from "../../../PopupChecklist/PopupChecklist";
import EditTablePopup from "../../EditTablePopup/EditTablePopup";
import { getStoredData } from "../../../../../json/fecthData";

const getResolvedId = (entry) => {
  if (!entry) return "";
  if (typeof entry === "object") return entry._id || "";
  return entry;
};

const TableCellRenderer = ({
  product,
  field,
  value,
  isEditable,
  dropdownData,
  editingCell,
  editedValue,
  setEditedValue,
  setEditingCell,
  pendingChanges,
  setPendingChanges,
  FileUploadButton,
  NumberPartsEditor,
  renderField,
  handleCellClick,
  getDisplayLabel,
  updatePendingChanges,
  handleDoubleClick,
  currentProducts,
  handlePopupSuccess
}) => {
  const fieldValue = pendingChanges?.[product._id]?.[field.fields] ?? product[field.fields];
  const isPopup = field.editPopUp === "true" && !!field.popupCalling;
  const isMulti = field.multiple && Array.isArray(fieldValue);
  const isFile = field.type === "file";
  const isNumberParts = field.type === "numberparts";
  const isPhoto = field.fields === "photo";

  const popupFields =
    typeof field.popupCalling === "string"
      ? getStoredData()?.[1]?.[field.popupCalling] || []
      : field.popupCalling;





  const isInEditMode =
    editingCell?.rowId === product._id &&
    editingCell?.fieldName === field.fields;

  const showPopupSelectButtons = () => {
    const entryList = Array.isArray(fieldValue)
      ? fieldValue.filter(Boolean)
      : [fieldValue].filter(Boolean);

    if (
      Array.isArray(fieldValue) &&
      editingCell.popupMode !== "add" &&
      !editingCell.popupEntryId &&
      entryList.length > 0
    ) {
      return (
        <div className="popup-select-multiple">
          <p>Select an entry to edit:</p>
          {entryList.map((entryId, idx) => (
            <button
              key={idx}
              onClick={() =>
                setEditingCell((prev) => ({
                  ...prev,
                  popupEntryId: entryId,
                  popupMode: "edit",
                }))
              }
              className="popup-select-btn"
            >
              {typeof entryId === "object"
                ? entryId?.itemCode ||
                  entryId?.name ||
                  entryId?._id ||
                  "Unnamed"
                : entryId}
            </button>
          ))}
          <button
            className="popup-select-btn add-new-entry"
            onClick={() =>
              setEditingCell((prev) => ({
                ...prev,
                popupEntryId: null,
                popupMode: "add",
                showPopup: true,
              }))
            }
          >
            ➕ Add New
          </button>
        </div>
      );
    }

    if (
      editingCell.popupMode === "add" ||
      (!entryList.length && !editingCell.popupEntryId)
    ) {
      return (
       <EditTablePopup
  id={null}
  api={field.api}
  fields={popupFields}
  onSuccess={(newEntry) => {
    handlePopupSuccess(newEntry);   // ✅ update pendingChanges
    setEditingCell(null);           // ✅ close popup
  }}
/>

      );
    }

    return (
      <EditTablePopup
  id={getResolvedId(editingCell?.popupEntryId || entryList?.[0])}
  api={field.api}
  fields={popupFields}
  onSuccess={(newEntry) => {
    handlePopupSuccess(newEntry);   // ✅ update pendingChanges
    setEditingCell(null);           // ✅ close popup
  }}
/>

    );
  };

  return (
    <td
      className={`table-cell field-${field.fields} ${
        isEditable ? "editable-cell" : ""
      } ${!value ? "empty-cell" : ""}`}
      onDoubleClick={() =>
        isEditable &&
        handleDoubleClick(
          field,
          value,
          isEditable,
          product._id,
          handleCellClick,
          setEditingCell
        )
      }
      onClick={
        isPopup && isMulti
          ? (e) => {
              const chip = e.target.closest(".multi-chip");
              const entryId = chip?.dataset?.entryId;
              if (entryId) {
                setEditingCell({
                  rowId: product._id,
                  fieldName: field.fields,
                  showPopup: true,
                  popupEntryId: entryId,
                });
              }
            }
          : undefined
      }
    >
      {/* ========== EDIT MODE ========== */}
      {isInEditMode ? (
        isPopup ? (
          showPopupSelectButtons()
        ) : field.api && field.multiple ? (
          <>
            <div
              className="multi-select-display"
              onClick={() =>
                setEditingCell({
                  rowId: product._id,
                  fieldName: field.fields,
                  showPopup: true,
                  popupMode: "select",
                })
              }
            >
              {Array.isArray(value) && value.length > 0 ? (
                value.map((val, i) => (
                  <span key={val?._id || i} className="multi-chip">
                    {getDisplayLabel(val, field.fields, dropdownData)}
                  </span>
                ))
              ) : (
                <span className="placeholder">No entries</span>
              )}
            </div>
            {editingCell?.showPopup && (
              <PopupChecklist
                options={dropdownData[field.fields] || []}
                selectedValues={
                  Array.isArray(value)
                    ? value
                        .filter(Boolean)
                        .map((val) => (typeof val === "object" ? val._id : val))
                    : []
                }
                onChange={(updatedValues) => {
                  const current = Array.isArray(value)
                    ? value
                        .filter(Boolean)
                        .map((val) => (typeof val === "object" ? val._id : val))
                    : [];
                  if (!isEqual(current, updatedValues)) {
                    updatePendingChanges(product._id, field.fields, updatedValues, setPendingChanges);

                  }
                  setEditingCell(null);
                }}
                onClose={() => setEditingCell(null)}
              />
            )}
          </>
        ) : isFile ? (
          <div className="file-field-container">
            <div className="file-actions">
              <button
                onClick={() => value && window.open(value, "_blank")}
                className="view-file-button"
                disabled={!value}
              >
                <i className="fas fa-eye"></i>
              </button>
              <button
                onClick={() => value && navigator.clipboard.writeText(value)}
                className="copy-link-button"
                disabled={!value}
              >
                <i className="fas fa-copy"></i>
              </button>
              <FileUploadButton
                fieldName={field.fields}
                productId={product._id}
                onUploadSuccess={(id, fieldName, link) => {
                  updatePendingChanges(id, fieldName, link, setPendingChanges);
                }}
              />
            </div>
          </div>
        ) : isNumberParts ? (
          <NumberPartsEditor
            product={product}
            field={field}
            editedValue={editedValue}
            setEditedValue={setEditedValue}
            setPendingChanges={setPendingChanges}
            setEditingCell={setEditingCell}
            currentProducts={currentProducts}
          />
        ) : (
          <input
            type={field.type === "date" ? "date" : "text"}
            value={editedValue}
            onChange={(e) => setEditedValue(e.target.value)}
            onBlur={() => {
              const trimmed =
                typeof editedValue === "string"
                  ? editedValue.trim()
                  : editedValue;
              if (!isEqual(value, trimmed)) {
                updatePendingChanges(product._id, field.fields, trimmed, setPendingChanges);

              }
              setEditingCell(null);
            }}
            autoFocus
            className="editable-input"
          />
        )
      ) : (
        // ========== READ MODE ==========
        (() => {
          if (isPhoto) {
            return (
              <img
                src={value}
                alt={product.title}
                className="photo-thumbnail"
              />
            );
          }

          const raw = product[field.fields];
          let displayText = "";

          if (field.api) {
            const apiField = field.apiField || "name";
            displayText = Array.isArray(raw)
              ? raw.map((item, idx) => {
                  const label =
                    typeof item === "object"
                      ? item?.[apiField] ||
                        item?.name ||
                        item?.userId ||
                        item?._id ||
                        `Entry ${idx + 1}`
                      : dropdownData[field.fields]?.find(
                          (opt) => opt.id === item
                        )?.label || item;

                  return (
                    <span
                      key={getResolvedId(item)}
                      className="multi-chip"
                      data-entry-id={getResolvedId(item)}
                    >
                      {label}
                    </span>
                  );
                })
              : typeof raw === "object"
              ? raw?.[apiField] || raw?.name || raw?.userId || raw?._id || "N/A"
              : raw || "";
          } else if (field.type === "date" && value) {
            displayText = new Date(value).toLocaleDateString("en-GB");
          } else {
            displayText =
              typeof value === "string" ? value : String(value ?? "");
          }

          const maxLength = 80;
          const isExpanded =
            editingCell?.rowId === product._id &&
            editingCell?.fieldName === field.fields;

          return displayText.length > maxLength ? (
            <div className="expandable-text">
              {isExpanded
                ? displayText
                : `${displayText.slice(0, maxLength)}...`}
              <span
                className="read-more-btn"
                onClick={() =>
                  setEditingCell(
                    isExpanded
                      ? null
                      : {
                          rowId: product._id,
                          fieldName: field.fields,
                        }
                  )
                }
              >
                {isExpanded ? " Read Less" : " Read More"}
              </span>
            </div>
          ) : (
            displayText || renderField(displayText, field.fields, product._id)
          );
        })()
      )}
    </td>
  );
};

export default TableCellRenderer;
